import React, { Component } from "react";
import Button from "react-bootstrap/lib/Button";
import PromoSpendInputMasking from "../../components/promo-spend/PromoSpendInputMasking";
import EventEmitter from "../../services/event-emitter";
import { logError } from "../../services/utils";
import { postRequest, putRequest } from "../../api/ApiService";
import HelpIconButtonWithTooltipAndTypeformModal from "../../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import _, { map } from "lodash";
import { incrementUnacceptedDecisions } from "../../api/SubmitDecisions";
import MgBusinessCaseContent from "../../components/typeform/MgBusinessCaseContent";
import Fragment from "react-dot-fragment";

const INPUT_MIN_VALUE = 0;
const INPUT_MAX_VALUE = 99999999;
const DEFAULT_DIGITAL = 100000;
const DEFAULT_TRADITIONAL = 100000;

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

function initProducts(products) {
  let result = _.cloneDeep(products);

  Object.keys(result).forEach(product_id => {
    const product = result[product_id];

    if (product.digital_spend_id === 0 || product.player_digital === null) {
      result[product_id].digital_spend = DEFAULT_DIGITAL;
    }

    if (
      product.traditional_spend_id === 0 ||
      product.player_traditional === null
    ) {
      result[product_id].traditional_spend = DEFAULT_TRADITIONAL;
    }
  });

  return result;
}

export default class ModalPMDecisionsPromotionalSpend extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: initProducts(props.products),
      original_products: props.products,
      isSaving: false,
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      rounds: props.rounds
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  openModal = () => {
    if (this.props.tourMode === true) {
      this.showModalTour();
      return;
    }

    this.showModal();
  };

  showPopup = spend => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      <Fragment>
        <b>Uh Oh! Very low promo!</b><br />
        You should double check the <a href="/analysis/bcase" target="_blank">business case</a> to
        see what others have spent on their marketing budget.
      </Fragment>,
      <Fragment>
        You don't have to spend the same amount as others, but it's in your best
        interests to spend more than ${numberWithCommas(spend)} if this is the first time
        promoting this product.
      </Fragment>
    ]);
  };

  componentDidMount() {
    this.eventemitter.on("product-marketing-show-modal2", this.showModal);
    this.eventemitter.on("product-marketing-hide-modal2", this.hideModal);
    this.eventemitter.on("product-marketing-force-update2", this.rerender);
    this.eventemitter.on("pm-decisions-open-modal2", this.openModal);
  }

  componentWillUnmount() {
    this.eventemitter.off("product-marketing-show-modal2", this.showModal);
    this.eventemitter.off("product-marketing-hide-modal2", this.hideModal);
    this.eventemitter.off("product-marketing-force-update2", this.rerender);
    this.eventemitter.off("pm-decisions-open-modal2", this.openModal);
  }

  rerender = () => {
    this.forceUpdate();
  };

  showModalTour = () => {
    // do nothing
  };

  showModal = () => {
    if (this.props.tourMode === true) {
      window.$("#myModalDecisionsPromotionalSpend").data("bs.modal", null);
      window.$("#myModalDecisionsPromotionalSpend").modal({
        keyboard: false,
        backdrop: "static",
        show: true
      });
      return;
    }

    if (this.props.hasAccess === true) {
      window.$("#myModalDecisionsPromotionalSpend").data("bs.modal", null);
      window.$("#myModalDecisionsPromotionalSpend").modal("show");
    } else {
      this.props.showRoleAlert();
    }
  };

  hideModal = () => {
    window.$("#myModalDecisionsPromotionalSpend").modal("hide");
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.currentRound !== nextProps.currentRound ||
      this.state.roundInUrl !== nextProps.roundInUrl ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) ||
      this.state.original_products !== nextProps.products
    ) {
      this.setState({
        products: initProducts(nextProps.products),
        original_products: nextProps.products,
        currentRound: nextProps.currentRound,
        roundInUrl: nextProps.roundInUrl,
        rounds: nextProps.rounds
      });
    }
  }

  updateState = (e, nonFormattedValue) => {
    let input = e.target;
    let value = nonFormattedValue.floatValue;
    let name = input.dataset.name;
    let productId = parseInt(input.dataset.productId, 10);
    let products = this.state.products;

    if (productId in products) {
      if (value < INPUT_MIN_VALUE) {
        value = INPUT_MIN_VALUE;
      }

      if (value > INPUT_MAX_VALUE) {
        value = INPUT_MAX_VALUE;
      }

      if (name === "traditionalMarketing") {
        products[productId].traditional_spend = value;

        this.setState({
          products
        });
      } else if (name === "digitalMarketing") {
        products[productId].digital_spend = value;

        this.setState({
          products
        });
      }
    }
  };

  createPromo(data) {
    return postRequest(`${process.env.REACT_APP_API_URL}team/promos/`).send(
      data
    );
  }

  updatePromo(data, promo_id) {
    return putRequest(
      `${process.env.REACT_APP_API_URL}team/promos/${promo_id}/`
    ).send(data);
  }

  updateProduct = e => {
    if (this.props.tourMode === true) {
      // do nothing
      return;
    }

    this.setState({
      isSaving: true
    });

    let requests = [];

    Object.keys(this.state.products).forEach(product_id => {
      let product = this.state.products[product_id];

      const data_traditional = {
        client: this.props.marketing_clients["Traditional Marketing"],
        spend: parseInt(product.traditional_spend, 10),
        product: parseInt(product_id, 10)
      };

      const data_digital = {
        client: this.props.marketing_clients["Digital Marketing"],
        spend: parseInt(product.digital_spend, 10),
        product: parseInt(product_id, 10)
      };

      if (product.traditional_spend_id > 0) {
        requests.push(
          this.updatePromo(data_traditional, product.traditional_spend_id)
        );
      } else {
        requests.push(this.createPromo(data_traditional));
      }

      if (product.digital_spend_id > 0) {
        requests.push(this.updatePromo(data_digital, product.digital_spend_id));
      } else {
        requests.push(this.createPromo(data_digital));
      }
    });

    const joinRequest = Promise.all(requests);

    joinRequest
      .then(res => {
        const data = map(res, item => ({
          client: item.body.client,
          spend: item.body.spend
        }));
        const client = data.find(i => i.client === 1);
        if (client && client.spend <= 200000) {
          this.showPopup(client.spend);
        }

        this.setState(
          {
            isSaving: false
          },
          () => {
            this.props.showSuccessMessage('New promo decision was successfully set for your product(s)');
            incrementUnacceptedDecisions("marketing");
            window.$("#myModalDecisionsPromotionalSpend").modal("hide");
            this.props.reloadData();
            this.props.getSubmissionData();
          }
        );
      })
      .catch(err => {
        logError(err, "ModalPMDecisionsPromotionalSpend", "updateProduct");
      });
  };

  get isSaveDisabled() {
    if (this.props.tourMode === false) {
      return this.state.isSaving;
    }

    return true;
  }

  render() {
    const isSaving = this.state.isSaving;
    let modalClassName = "modal fade";
    if (this.props.tourMode === true) {
      modalClassName = "modal";
    }

    return (
      <div
        className={modalClassName}
        id="myModalDecisionsPromotionalSpend"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-bigger">
          <div className="modal-content">
            <div
              id="product-marketing-promo-spend-header"
              className="modal-header"
            >
              <div className="row">
                <div className="col-xs-7">
                  <h4
                    className="modal-title title-light-blue"
                    id="myModalLabel"
                  >
                    Promotional Spend
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...MgBusinessCaseContent.PROMOTIONAL_SPEND}
                    />
                  </h4>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="table-responsive mt-20">
                <form id="form-promotional">
                  <table className="table">
                    <thead>
                      <tr className="border-none">
                        <th className="text-center">
                          <span></span>
                        </th>
                        <th className="text-center">
                          <span>Traditional Marketing</span>
                        </th>
                        <th className="text-center">
                          <span>Digital Marketing</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(this.state.products).map(product_id => {
                        let product = this.state.products[product_id];

                        return (
                          <tr
                            className="text-center border-none"
                            key={product_id}
                          >
                            <th className="middle">Product {product.name}</th>
                            <td>
                              <PromoSpendInputMasking
                                name="traditionalMarketing"
                                productId={product_id}
                                value={product.traditional_spend}
                                onChange={this.updateState}
                              />
                            </td>
                            <td>
                              <PromoSpendInputMasking
                                name="digitalMarketing"
                                productId={product_id}
                                value={product.digital_spend}
                                onChange={this.updateState}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
            <div className="modal-footer text-center">
              <button
                type="button"
                className="btn btn-cancel"
                data-dismiss="modal"
                disabled={this.props.tourMode}
              >
                Cancel
              </button>
              <Button
                id="product-marketing-promo-spend-save"
                className="btn btn-save"
                disabled={this.isSaveDisabled}
                onClick={!isSaving ? this.updateProduct : null}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modal/ModalPMDecisionsPromotionalSpend.js